import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';
export function ContactForm() {
  const form = useRef<HTMLFormElement>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const sendEmail = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.current) return;
    setIsSubmitting(true);
    setSubmitStatus('idle');
    emailjs.sendForm('service_doctorecommerce', 'template_roofing_lead', form.current, 'YOUR_PUBLIC_KEY').then(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      form.current?.reset();
    }, error => {
      console.error('FAILED...', error.text);
      setIsSubmitting(false);
      setSubmitStatus('error');
    });
  };
  return <section id="contact-form" className="py-16 md:py-24 px-4 bg-carbon border-t border-dark-border" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-12" data-id="element-3">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-gold mb-4" data-id="element-4">
            Solicita Tu Auditoría de Zona Gratuita
          </h2>
          <p className="text-base md:text-lg text-gray-sec" data-id="element-5">
            Completa el formulario y te contactamos en menos de 24 horas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#0A0A0A] border border-[#151515] rounded-2xl p-6 md:p-10 shadow-lg" data-id="element-6">
          <form ref={form} onSubmit={sendEmail} className="space-y-6" data-id="element-7">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-8">
              <div data-id="element-9">
                <label htmlFor="user_name" className="sr-only" data-id="element-10">
                  Nombre completo
                </label>
                <input type="text" name="user_name" id="user_name" required placeholder="Nombre completo *" className="w-full bg-[#0A0A0A] border border-[#151515] text-white placeholder-gray-500 rounded-lg px-4 py-3 focus:outline-none focus:border-gold/50 transition-colors" data-id="element-11" />
              </div>
              <div data-id="element-12">
                <label htmlFor="user_email" className="sr-only" data-id="element-13">
                  Email
                </label>
                <input type="email" name="user_email" id="user_email" required placeholder="Email *" className="w-full bg-[#0A0A0A] border border-[#151515] text-white placeholder-gray-500 rounded-lg px-4 py-3 focus:outline-none focus:border-gold/50 transition-colors" data-id="element-14" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-15">
              <div data-id="element-16">
                <label htmlFor="user_phone" className="sr-only" data-id="element-17">
                  Teléfono
                </label>
                <input type="tel" name="user_phone" id="user_phone" required placeholder="Teléfono *" className="w-full bg-[#0A0A0A] border border-[#151515] text-white placeholder-gray-500 rounded-lg px-4 py-3 focus:outline-none focus:border-gold/50 transition-colors" data-id="element-18" />
              </div>
              <div data-id="element-19">
                <label htmlFor="company_name" className="sr-only" data-id="element-20">
                  Nombre de tu compañía
                </label>
                <input type="text" name="company_name" id="company_name" required placeholder="Nombre de tu compañía *" className="w-full bg-[#0A0A0A] border border-[#151515] text-white placeholder-gray-500 rounded-lg px-4 py-3 focus:outline-none focus:border-gold/50 transition-colors" data-id="element-21" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-22">
              <div data-id="element-23">
                <label htmlFor="company_instagram" className="sr-only" data-id="element-24">
                  Instagram de la compañía
                </label>
                <input type="text" name="company_instagram" id="company_instagram" placeholder="Instagram (ej: @tuempresa)" className="w-full bg-[#0A0A0A] border border-[#151515] text-white placeholder-gray-500 rounded-lg px-4 py-3 focus:outline-none focus:border-gold/50 transition-colors" data-id="element-25" />
              </div>
              <div data-id="element-26">
                <label htmlFor="company_website" className="sr-only" data-id="element-27">
                  Website
                </label>
                <input type="text" name="company_website" id="company_website" placeholder="Website (ej: www.tuempresa.com)" className="w-full bg-[#0A0A0A] border border-[#151515] text-white placeholder-gray-500 rounded-lg px-4 py-3 focus:outline-none focus:border-gold/50 transition-colors" data-id="element-28" />
              </div>
            </div>

            <div data-id="element-29">
              <label htmlFor="current_clients" className="block text-sm text-gray-400 mb-2" data-id="element-30">
                ¿Cuántos clientes nuevos consigues por semana?
              </label>
              <select name="current_clients" id="current_clients" className="w-full bg-[#0A0A0A] border border-[#151515] text-white rounded-lg px-4 py-3 focus:outline-none focus:border-gold/50 transition-colors appearance-none" data-id="element-31">
                <option value="0-2" data-id="element-32">0-2</option>
                <option value="3-5" data-id="element-33">3-5</option>
                <option value="6-10" data-id="element-34">6-10</option>
                <option value="10+" data-id="element-35">10+</option>
              </select>
            </div>

            <div data-id="element-36">
              <label htmlFor="goal_clients" className="block text-sm text-gray-400 mb-2" data-id="element-37">
                ¿Cuál es tu meta semanal de clientes nuevos?
              </label>
              <select name="goal_clients" id="goal_clients" className="w-full bg-[#0A0A0A] border border-[#151515] text-white rounded-lg px-4 py-3 focus:outline-none focus:border-gold/50 transition-colors appearance-none" data-id="element-38">
                <option value="5-10" data-id="element-39">5-10</option>
                <option value="10-20" data-id="element-40">10-20</option>
                <option value="20-30" data-id="element-41">20-30</option>
                <option value="30+" data-id="element-42">30+</option>
              </select>
            </div>

            <div data-id="element-43">
              <label htmlFor="has_done_ads" className="block text-sm text-gray-400 mb-2" data-id="element-44">
                ¿Has hecho publicidad digital antes?
              </label>
              <select name="has_done_ads" id="has_done_ads" className="w-full bg-[#0A0A0A] border border-[#151515] text-white rounded-lg px-4 py-3 focus:outline-none focus:border-gold/50 transition-colors appearance-none" data-id="element-45">
                <option value="Sí" data-id="element-46">Sí</option>
                <option value="No" data-id="element-47">No</option>
                <option value="Un poco pero no funcionó" data-id="element-48">
                  Un poco pero no funcionó
                </option>
              </select>
            </div>

            <div data-id="element-49">
              <label htmlFor="ad_spend" className="block text-sm text-gray-400 mb-2" data-id="element-50">
                ¿Cuánto has invertido en marketing digital hasta ahora?
              </label>
              <select name="ad_spend" id="ad_spend" className="w-full bg-[#0A0A0A] border border-[#151515] text-white rounded-lg px-4 py-3 focus:outline-none focus:border-gold/50 transition-colors appearance-none" data-id="element-51">
                <option value="Nada" data-id="element-52">Nada</option>
                <option value="Menos de $1,000" data-id="element-53">Menos de $1,000</option>
                <option value="$1,000-$5,000" data-id="element-54">$1,000-$5,000</option>
                <option value="$5,000-$10,000" data-id="element-55">$5,000-$10,000</option>
                <option value="Más de $10,000" data-id="element-56">Más de $10,000</option>
              </select>
            </div>

            <button type="submit" disabled={isSubmitting} className="w-full bg-gradient-to-r from-[#F2B705] to-[#E5A800] text-carbon font-bold rounded-xl px-8 py-4 text-center hover:brightness-110 transition-all tracking-wide disabled:opacity-70 disabled:cursor-not-allowed mt-4" data-id="element-57">
              {isSubmitting ? 'ENVIANDO...' : 'ENVIAR SOLICITUD'}
            </button>

            {submitStatus === 'success' && <p className="text-emerald text-center font-medium mt-4" data-id="element-58">
                ¡Solicitud enviada! Te contactaremos pronto.
              </p>}
            {submitStatus === 'error' && <p className="text-red-500 text-center font-medium mt-4" data-id="element-59">
                Hubo un error al enviar. Por favor intenta de nuevo o agenda
                directamente.
              </p>}

            <div className="text-center mt-6" data-id="element-60">
              <p className="text-gray-sec text-sm mb-2" data-id="element-61">
                O agenda directamente:
              </p>
              <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline text-sm font-medium" data-id="element-62">
                Agendar en Google Calendar →
              </a>
            </div>
          </form>
        </motion.div>
      </div>
    </section>;
}